import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import {
  WithStyles,
  createStyles,
  Button,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Tooltip,
  Link,
} from "@material-ui/core";

import { MyPATDialog } from "../../common";
import moment from "moment";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

function arrowGenerator(color: string) {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: "-0.95em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: `transparent transparent ${color} transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: "-0.95em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "1em 1em 0 1em",
        borderColor: `${color} transparent transparent transparent`,
      },
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: "-0.95em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 1em 1em 0",
        borderColor: `transparent ${color} transparent transparent`,
      },
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: "-0.95em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 0 1em 1em",
        borderColor: `transparent transparent transparent ${color}`,
      },
    },
  };
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    searchIcon: {
      fill: theme.palette.text.secondary,
      opacity: 0.5,
    },
    formControl: {
      margin: theme.spacing.unit,
      minWidth: 120,
      width: "95%",
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    chip: {
      margin: theme.spacing.unit / 4,
    },
    noLabel: {
      marginTop: theme.spacing.unit * 3,
    },
    author: {
      margin: "30px auto 20px",
      display: "block",
    },
    requiredHeading: {
      color: theme.palette.secondary.main,
    },
    widthMd: {
      minWidth: 680,
      maxWidth: 700,
      margin: "auto",
      minHeight: 250,
    },
    tableContainer: {
      width: 680,
      maxHeight: 230,
      minHeight: 150,
      position: "absolute",
      overflowY: "auto",
      margin: 0,
      background: "#FFFFFF",
      border: "1px solid #E4E4E4",
      borderRadius: 4,
      "& td": {
        borderBottom: "1px solid #fff",
        fontSize: 14,
        color: "#666666",
        padding: "10px 24px 10px",
        clear: "both",
        // overflow: "hidden",
        // whiteSpace: "nowrap",
      },
    },
    okBtn: {
      margin: "2px 0px -8px",
      width: 132,
    },
    tableCell: {
      fontFamily: "Nunito",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: 16,
      lineHeight: "18px",
      textAlign: "center",
      color: "rgb(51, 51, 51)",
    },
    borderNone: {
      border: "none",
      height: 40,
    },
    paddingSM: {
      padding: 0,
      minWidth: 130,
    },
    tableRow: {
      height: 34,
    },
    textTruncate: {
      width: "100%",
      maxWidth: "82px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
    arrowPopper: arrowGenerator(theme.palette.grey[700]),
    arrow: {
      position: "absolute",
      fontSize: 6,
      width: "3em",
      height: "3em",
      "&::before": {
        content: '""',
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        borderStyle: "solid",
      },
    },
    bootstrapPopper: arrowGenerator(theme.palette.common.black),
    bootstrapTooltip: {
      backgroundColor: theme.palette.common.black,
    },
    bootstrapPlacementLeft: {
      margin: "8px 0",
    },
    tooltipTd:{
      whiteSpace:'initial !important' as 'initial',
    },
    Flex: {
      display: 'flex',
      justifyContent: 'center',
      '& a':{
        cursor: 'pointer',
      },
    },
  });

//@ts-ignore
interface Props extends WithStyles<typeof styles> {
  isOpen: boolean;
  contentHistory: any;
  onClose: Function;
	type: string
}
interface States {
  arrowRef: any,
  open: any,
  selectedId: string
	// close: any,
}

class RevisionHistoryModal extends Component<Props, States> {
  constructor(props: Props) {
    super(props);
    this.state = {
      open: false,
      arrowRef: null,
      selectedId: ''
    };
  }

  handleArrowRef = (node: any) => {
    this.setState({
      arrowRef: node,
    });
  };

  handleTooltipClose = () => {
    this.setState({ open: false,
      selectedId: ''
     });
  };

  handleTooltipOpen = (event: any) => {
    this.setState({ open: true,
    selectedId: event.target.id
   });
  };
  renderTooltip(history:  any) {
    const { classes } = this.props
    return(
      <Tooltip
      title={
        <>
          <span>{history.comment ? history.comment : '-'}</span>
          <span className={classes.arrow} ref={this.handleArrowRef} />

        </>
      }
      classes={{
        tooltip: classes.bootstrapTooltip,
        popper: classes.bootstrapPopper,
        tooltipPlacementLeft: classes.bootstrapPlacementLeft,
      }} 
      PopperProps={{
        disablePortal: true,
        modifiers: {
          arrow: {
            enabled: Boolean(this.state.arrowRef),
            element: this.state.arrowRef,
          },
        },
      }}
      onClose={this.handleTooltipClose}
      open={this.state.open && this.state.selectedId === history._id}
      disableFocusListener
      disableHoverListener
      disableTouchListener
    >
      <Grid className={classes.Flex}>
      <Typography  className={`${history.comment && history.comment.length > 11 ? classes.textTruncate : ""}`}>{history.comment ? history.comment : '-'}
      </Typography>
      {
        history.comment && history.comment.length > 11 && ( 
        <Link onClick={this.handleTooltipOpen.bind(this)} id={history._id}>View</Link>
        )
      }
      </Grid>
    </Tooltip>
    )
  }

	render() {
		const { isOpen, onClose, contentHistory, classes, type } = this.props
		return (
			<div>
				<MyPATDialog
					dialogHeading={`${type === "question" ? "Question History" : "Test History"}`}
					dialogOpen={isOpen}
					onDialogClose={onClose}
					isAlignCenter={true}
					customButtonVariant="withoutBorderCloseIcon"
					dialogHasActions={false}
					otherDialogProps={{
						fullWidth: false,
						maxWidth: false,
					}}
				>
				<Grid container className={classes.widthMd}>
					
					<Grid className={classes.tableContainer}>
						<Table>
							<TableHead>
								<TableRow classes={{ head: classes.tableRow }}>
									<TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Revision No.</TableCell>
									<TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Revised By</TableCell>
									<TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Role</TableCell>
									<TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Date, Time</TableCell>
									<TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Field Updated</TableCell>
									{type === "question" && ( <>
									<TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Old</TableCell>
									<TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>New</TableCell>	
										</>	
									)}
									<TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Comment</TableCell>
								</TableRow>
							</TableHead>

							<TableBody>
								{
									contentHistory.map((history: any, index: number) => {
										const date = moment(history.updatedAt).format('DD/MM/YYYY');
										const time = moment(history.updatedAt).format('hh:mm A');
										return <TableRow key={index}>
											<TableCell align="center">{index + 1}</TableCell>
											<TableCell align="center">{history.createdBy.email}</TableCell>
											<TableCell align="center">{history.createdBy && history.createdBy.roleInfo && history.createdBy.roleInfo.role}</TableCell>
											<TableCell align="center">{date}, {time}</TableCell>
											<TableCell align="center">{history.fieldUpdate ? history.fieldUpdate : '-'}</TableCell>
											{type === "question" && ( <>
												<TableCell align="center">{history.createdBy.from ? history.createdBy.from : '-'}</TableCell>
												<TableCell align="center">{history.createdBy.to ? history.createdBy.to : '-'} </TableCell>	
								     		</>	
									        )}
											<TableCell align="center">
                        {this.state.open && this.state.selectedId === history._id && (
                        <ClickAwayListener
                            onClickAway={this.handleTooltipClose}
                          > 
                         {this.renderTooltip(history)}
                        </ClickAwayListener> 
                        )}
                        {!(this.state.open && this.state.selectedId === history._id) && (
                         this.renderTooltip(history)
                        )}
                        </TableCell>
										</TableRow>
									})
								}
							</TableBody>
						</Table>
					</Grid>					
					</Grid>

          <Grid container justify="flex-end" alignItems="flex-end">
            <Button
              variant="contained"
              color="primary"
              className={classes.okBtn}
              onClick={(e) => {
                onClose();
              }}
            >
              Ok
            </Button>
          </Grid>
        </MyPATDialog>
      </div>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(RevisionHistoryModal);
